import React from "react";
import ReactDOM from "react-dom";
import "assets/scss/material-kit-react.scss?v=1.8.0";
import { SnackbarProvider } from "notistack";
import "semantic-ui-css/semantic.min.css";
import App from "views";

// @react-pdf/renderer mengambil fetch tanpa binding ke window — fix untuk dev mode
if (typeof window !== "undefined" && window.fetch) {
  window.fetch = window.fetch.bind(window);
}

// @react-pdf/renderer menggunakan process di web worker yang tidak di-polyfill webpack
if (typeof window !== "undefined" && typeof window.process === "undefined") {
  window.process = { env: { NODE_ENV: "development" } };
}

ReactDOM.render(
  <SnackbarProvider>
    <App />
  </SnackbarProvider>,
  document.getElementById("root")
);
